export const password = {
    'reset-text': `Ju lutemi shkruani emailin tuaj. Ne do t'ju dërgojmë një fjalëkalim të përkohshëm.`,
    forgot: 'Keni harruar fjalëkalimin?',
    current: 'Fjalëkalimi aktual',
    new: 'Fjalëkalim i ri',
    repeat: 'Përsëritni fjalëkalimin e ri',
    reset: 'Rivendosni fjalëkalimin'
  };
  